import Vue from "vue";
import VueRouter from "vue-router";
//import { component } from 'vue/types/umd'

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "License",
        component: () =>
            import(/* webpackChunkName: "login" */ "../views/LicenseView.vue"),
        meta: {},
    },
    {
        path: "/lic",
        name: "makeLicense",
        component: () =>
            import(/* webpackChunkName: "makeLicense" */ "../views/MakeLicenseView.vue"),
        meta: {},
    },
    {
        path: "/download",
        name: "scannerDownload",
        component: () =>
            import(/* webpackChunkName: "scannerDownload" */ "../views/ScannerDownload.vue"),
        meta: {},
    },
    {
        path: "/login",
        name: "adminLogin",
        component: () =>
            import(/* webpackChunkName: "adminLogin" */ "../views/LoginView.vue"),
        meta: {requiresAuth: false},
    },
    {
        path: '/admin',
        redirect: '/admin/company'  // /admin 경로로 접근하면 /admin/company로 리디렉션
    },
    {
        path: "/admin/company",
        name: "adminHome",
        component: () =>
            import(/* webpackChunkName: "adminHome" */ "../views/AdminHomeView.vue"),
        meta: {requiresAuth: true},
    },
    {
        path: "/admin/detail",
        name: "companyDetail",
        component: () =>
            import(/* webpackChunkName: "companyDetail" */ "../views/CompanyDetail.vue"),
        meta: {requiresAuth: true},
    },
    {
        path: "/admin/license",
        name: "adminLicense",
        component:() =>
            import(/* webpackChunkName: "adminLicense" */ "../views/AdminLicenseView.vue"),
        meta: {requiresAuth: true},
    },
    {
        path: "/admin/register",
        name: "adminCompany",
        component:() =>
            import(/* webpackChunkName: "adminCompany" */ "../views/AdminCompanyRegister.vue"),
        meta: {requiresAuth: true},
    },
    {
        path: "/admin/project",
        name: "adminProject",
        component:() =>
            import(/* webpackChunkName: "adminProject" */ "../views/AdminProject.vue"),
        meta: {requiresAuth: true},
    },
    {
        path: "/admin/projectdetail",
        name: "projectDetail",
        component:() =>
            import(/* webpackChunkName: "adminProject" */ "../views/projectDetail.vue"),
        meta: {requiresAuth: true},
    },
    {
        path: "/admin/projectregister",
        name: "projectRegister",
        component:() =>
            import(/* webpackChunkName: "adminProject" */ "../views/AdminProjectRegister.vue"),
        meta: {requiresAuth: true},
    },

];

const router = new VueRouter({
    mode: "history",
    routes,
});

router.beforeEach((to, from, next) => {
    const token = sessionStorage.getItem('token');
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!token) {
            next('/login');
        } else {
            next();
        }
    } else if (to.path === '/login' && token) {
        next('/admin/company');
    } else {
        next()
    }
});
export default router;
